import { render, staticRenderFns } from "./customization-form.vue?vue&type=template&id=af4188a2&scoped=true"
import script from "./customization-form.vue?vue&type=script&lang=ts"
export * from "./customization-form.vue?vue&type=script&lang=ts"
import style0 from "./customization-form.vue?vue&type=style&index=0&id=af4188a2&prod&lang=scss&scoped=true"
import style1 from "./customization-form.vue?vue&type=style&index=1&id=af4188a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af4188a2",
  null
  
)

export default component.exports